import { render } from "./VisionFourFilters.vue?vue&type=template&id=16d4dc54"
import script from "./VisionFourFilters.vue?vue&type=script&lang=js"
export * from "./VisionFourFilters.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__